import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import { shuffle } from 'lodash';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from 'components/ErrorBoundary';
import CustomeDate from './customeDate';

const pharmacyData = [
  {
    Pharmacy: 'PharmaForce Rx #2548',
    CoveredEntity: 'PharmaForce General Hospital 1',
    RxCount: 4000,
    Savings: 155954,
  },
  {
    Pharmacy: 'PharmaForce Rx #10-1778',
    CoveredEntity: 'PharmaForce General Hospital 1',
    RxCount: 1000,
    Savings: 124000,
  },
  {
    Pharmacy: 'PharmaForce Rx #3478',
    CoveredEntity: 'PharmaForce General Hospital 1',
    RxCount: 523,
    Savings: 110000,
  },
  {
    Pharmacy: 'PharmaForce Rx #3149',
    CoveredEntity: 'PharmaForce General Hospital 1',
    RxCount: 659,
    Savings: 98456,
  },
  {
    Pharmacy: 'PharmaForce Rx #5274',
    CoveredEntity: 'PharmaForce General Hospital 1',
    RxCount: 256,
    Savings: 89254,
  },
  {
    Pharmacy: 'PharmaForce Rx #1478',
    CoveredEntity: 'PharmaForce FQHC 2',
    RxCount: 214,
    Savings: 75412,
  },
  {
    Pharmacy: 'PharmaForce Rx #2244',
    CoveredEntity: 'PharmaForce FQHC 2',
    RxCount: 854,
    Savings: 65123,
  },
  {
    Pharmacy: 'PharmaForce Rx #2576',
    CoveredEntity: 'PharmaForce FQHC 2',
    RxCount: 526,
    Savings: 64145,
  },
  {
    Pharmacy: 'PharmaForce Rx #4461',
    CoveredEntity: 'PharmaForce FQHC 2',
    RxCount: 1456,
    Savings: 62145,
  },
  {
    Pharmacy: 'PharmaForce Rx #2548',
    CoveredEntity: 'PharmaForce FQHC 2',
    RxCount: 1487,
    Savings: 59997,
  },
];

const TopPharmacy = (props) => {
  const [data, setData] = useState(pharmacyData);
  const [active, setActive] = useState('6');
  const chartData = {
    labels: data.map(({ Pharmacy }) => Pharmacy),
    datasets: [
      {
        label: 'Program Value',
        data: data.map(({ Savings }) => Savings),
        borderColor: 'rgba(152, 206, 143, 1)',
        backgroundColor: 'rgba(152, 206, 143, 1)',
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (item) {
            const { Pharmacy, CoveredEntity, RxCount } =
              data[item[0].dataIndex];
            return `${Pharmacy}\n${CoveredEntity}\nRx Count ${RxCount}`;
          },
          label: function (d,t) {
            var xLabel = d.dataset.label;
            var yLabel ='$' + d.formattedValue;
            return xLabel + ': ' + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'end'
            : 'start';
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'black'
            : 'black';
        },
        anchor: 'end',
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          value: {
            color: '#2B3346',
          },
        },
        formatter: function (value) {
          return (
            '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          );
        },
      },
    },
  };

  const handleActive = (title) => {
    if (active === title) return;
    const shuffleArry = shuffle(data);
    setActive(title);
    setData(shuffleArry);
  };

  const getDate = () => {
    setActive('custom')
  };

  return (
    <ErrorBoundary>
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white px-0'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className='f-20 font-weight-500 mb-0'>
                Top Performing Pharmacies
                <p className='dashboard-sub-text'>By Program Value</p>
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
                <NavItem>
                  <NavLink
                    className={
                      active === '3'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('3')}
                  >
                    3 Mon
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      active === '6'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('6')}
                  >
                    6 Mon
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      active === '12'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }
                    onClick={() => handleActive('12')}
                  >
                    1 Yr
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={
                      active === 'custom'
                        ? 'active-tab f-12 cursor-pointer'
                        : 'f-12 cursor-pointer'
                    }>
                    <CustomeDate getDate={getDate} active={active} />
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <div className='dashboard-chart-height-BITool'>
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
          <div className='view-report'>
            <a
              href="data:text/csv;charset=utf-8,'+escape(csv)+'"
              download='filename.csv'
            >
              {' '}
              View Report{' '}
            </a>
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default TopPharmacy;
